<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import fichaService from '@/src/services/fichaemergencia'

import formFichaEmergencia from '@src/components/form-ficha-emergencia.vue'
import refFichaEmergencia from '@src/components/rel-ficha-emergencia.vue'
import Produto from '@/src/services/produto'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formFichaEmergencia, refFichaEmergencia },
  data() {
    return {
      mostraForm: true,
      fichaEdit: {},
      fichas: [],
      filter: {},
      produtos: [],
      fichaFields: [
        {
          key: 'commercial_name',
          label: 'Nome comercial',
          class: 'size-col-20',
        },
        {
          key: 'map',
          label: 'Mapa',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idUser: '',
    }
  },
  computed: {
    rows() {
      return this.fichas.length
    },
  },

  watch: {},
  mounted() {
    //this.listaFichas()
   this.findAllProducts();
  },
  methods: {
    findAllProducts() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      Produto.listar(token).then((response) => {
        this.produtos = response.data.dados.filter(data => data.id_empresa_sistema == null);
        this.isLoading = false
      })
    },
    listandoByFilter() {
      if (this.filter != undefined) {
        this.isLoading = true
        fichaService
          .listarByMap(this.filter.mapa)
          .then((resposta) => {
            this.fichas = resposta.data.data
            this.isLoading = false
          })
          .catch((error) => {
            this.fichas = []
            this.isLoading = false
          })
      } else {
        this.listaFichas()
      }
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listaFichas() {
      this.isLoading = this.loading(this.isLoading)
      fichaService.listar().then((resposta) => {
        this.fichas = resposta.data.data
        this.isLoading = this.loading(this.isLoading)
      })
    },
    editRegister(ficha) {
      this.fichaEdit = ficha
      this.mostraForm = false
    },
    relFicha(ficha) {
      this.fichaEdit = ficha
      this.$bvModal.show('rel')
    },
    cadastra() {
      if (this.fichaEdit) {
        this.fichaEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listaFichas()
      }
    },
    modalDelete(id) {
      this.showModal = true
      this.idUser = id
    },
    empresaDeletar() {
      this.isLoading = this.loading(this.isLoading)
      empresaService
        .deleteEmpresa(this.idUser)
        .then((resposta) => {
          this.listando()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUser = null
      this.showModal = false
    },
    printFichaEmergencia() {
      this.$root.$emit('print-ficha-emergencia')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Ficha de emergência</div>
            <div class="subTitulo"
              >Visualize, edite e cadastre novas fichas de emergência na
              plataforma.</div
            >
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="cadastra">
                <span v-if="mostraForm">Novo</span>
                <span v-else>Lista</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div v-if="mostraForm" class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Nome" label-for="filter">
              <v-select
                class="style-select"
                label="nome"
                :options="produtos"
                :reduce="(item) => item.mapa"
                v-model="filter.mapa"
                :dense="true"
              ></v-select>
              <!-- <b-form-input
                id="filter"
                v-model="filter"
                type="text"
                placeholder="Digite o código do M.A.P.A"
              ></b-form-input> -->
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4 mt-4 pt-1">
            <button class="btn btn-primary" @click="listandoByFilter"
              >Pesquisar</button
            >
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <b-table
            show-empty
            striped
            hover
            responsive
            borderless
            bordered
            outlined
            small
            :items="fichas"
            :fields="fichaFields"
            :current-page="currentPage"
            :per-page="perPage"
            empty-text="Pesquise pelo código do M.A.P.A para localizar a Ficha de Emergência"
            empty-filtered-text="Pesquise pelo código do M.A.P.A para localizar a Ficha de Emergência"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button
                  v-b-tooltip.hover.bottom
                  title="Visualizar Ficha"
                  type="button"
                  class="btn btn-light"
                  @click="relFicha(row.item)"
                >
                  <i class="uil uil-search"></i>
                </button>
              </div>
            </template>
          </b-table>
          <!-- <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination> -->
        </div>

        <div v-else>
          <formFichaEmergencia :ficha="fichaEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light">Não</b-button>
        <b-button variant="danger" @click="empresaDeletar">Sim</b-button>
      </template>
    </b-modal>
    <b-modal id="rel" size="lg" :hide-footer="true">
      <refFichaEmergencia :ficha="fichaEdit" />
      <template v-slot:modal-header>
        <div class="ml-auto">
          <b-button
            class="mr-2"
            variant="danger"
            @click="$bvModal.hide('rel')"
            >Sair</b-button
          >         
          <b-button variant="primary" @click="printFichaEmergencia()"
            >Imprimir</b-button
          >
        </div>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>